module.exports = __webpack_public_path__ + "aac54189c2e8619a1830269c5d241205.png";